import { Drawer } from "@mui/material";
import PropTypes from "prop-types";
import UiIcon from "./UiIcon";
import "./ui.css";

// Right-hand filter panel. It only renders the controls it is given; the page
// owns the draft values and decides what Reset and Apply do.
export default function FilterDrawer({ open, onClose, onReset, onApply, title, children }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} className="simcc-drawer">
      <div className="simcc-drawer__header">
        <h3 className="simcc-drawer__title">{title}</h3>
        <button type="button" className="simcc-drawer__close" aria-label="Close" onClick={onClose}>
          <UiIcon name="x" size={16} strokeWidth={2.2} />
        </button>
      </div>
      <div className="simcc-drawer__body">{children}</div>
      <div className="simcc-drawer__footer">
        <button type="button" className="simcc-button simcc-button--ghost" onClick={onReset}>
          Reset
        </button>
        <button type="button" className="simcc-button simcc-button--primary" onClick={onApply}>
          Apply filters
        </button>
      </div>
    </Drawer>
  );
}

FilterDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
};

FilterDrawer.defaultProps = {
  title: "Filters",
  children: undefined,
};
